import React, { useState, useEffect } from "react";
import { DetailCard } from "./style";
import NumberFormat from "react-number-format";
const DetailsCard = props => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let newItems = [];
    Object.keys(props.data).map((item, index) => {
      let visible = true;
      if (!props.isHabiWeb && item == "conjunto_edificio" || !props.isHabiWeb && item == "direccion") {
        visible = false;
      } else {
        visible = true;
      }
      switch (item) {
        case "precio_venta":
          newItems.push({
            order: 1,
            name: "Precio de venta",
            value: props.data[item],
            type: "number",
            visible: visible
          });
          break;
        case "conjunto_edificio":
          newItems.push({
            order: 2,
            name: "Nombre del conjunto",
            value: props.data[item],
            visible: visible
          });
          break;
        case "direccion":
          newItems.push({
            order: 3,
            name: "Dirección",
            value: props.data[item],
            visible: visible
          });
          break;
        case "barriocomun":
          newItems.push({
            order: 4,
            name: !!props.TranslateNeighborhood ? props.TranslateNeighborhood : "Barrio",
            value: props.data[item],
            visible: visible
          });
          break;
        case "tipo_inmueble":
          newItems.push({
            order: 5,
            name: "Tipo de inmueble",
            value: props.data[item],
            visible: visible
          });
          break;
        case "anos_antiguedad":
          newItems.push({
            order: 6,
            name: "Antigüedad",
            value: props.data[item] + (props.data[item] == 1 ? " Año" : " Años"),
            visible: visible
          });
          break;
        case "num_piso":
          newItems.push({
            order: 7,
            name: "Piso",
            value: props.data[item],
            visible: visible
          });
          break;
        case "area":
          newItems.push({
            order: 8,
            name: "Área construida",
            value: props.data[item],
            visible: visible
          });
          break;
        case "num_habitaciones":
          newItems.push({
            order: 9,
            name: !!props.TranslateRoomPlural ? props.TranslateRoomPlural : "Habitaciones",
            value: props.data[item],
            visible: visible
          });
          break;
        case "banos":
          newItems.push({
            order: 10,
            name: "Baños",
            value: props.data[item],
            visible: visible
          });
          break;
        case "garajes":
          newItems.push({
            order: 11,
            name: !!props.TranslateGarage ? props.TranslateGarage : "Garajes",
            value: props.data[item],
            visible: visible
          });
          break;
        case "estrato":
          newItems.push({
            order: 12,
            name: "Estrato",
            value: props.data[item],
            visible: visible ? props.showLevel : false
          });
          break;
        case "remodelation":
          newItems.push({
            order: 13,
            name: "Remodelado",
            value: props.data[item] == 1 ? "Sí" : "No",
            visible: visible
          });
          break;
        case "num_ascensores":
          newItems.push({
            order: 14,
            name: !!props.TranslateElevatorPlural ? props.TranslateElevatorPlural : "Ascensores",
            value: props.data[item],
            visible: visible
          });
          break;
        case "last_admin_price":
          newItems.push({
            order: 15,
            name: !!props.TranslateAdministration ? props.TranslateAdministration : "Administración",
            value: props.showLevel ? "Revísalo con tu broker" : props.data[item],
            type: props.showLevel ? null : "number",
            visible: visible
          });
          break;
      }
    });
    setItems(newItems.sort(function (a, b) {
      if (a.order > b.order) {
        return 1;
      }
      if (a.order < b.order) {
        return -1;
      }
      return 0;
    }));
  }, [props.data]);
  return /*#__PURE__*/React.createElement(DetailCard, {
    ref: props.newReference,
    area: props.area
  }, /*#__PURE__*/React.createElement("h2", {
    className: "title-description",
    tabIndex: -1
  }, "Detalles del inmueble"), /*#__PURE__*/React.createElement("div", {
    className: "details"
  }, items.map(item => {
    if (item.visible) {
      if (item.type) {
        return /*#__PURE__*/React.createElement("div", {
          key: item.order + "-" + item.name
        }, /*#__PURE__*/React.createElement("p", {
          className: "title-detail"
        }, item.name), /*#__PURE__*/React.createElement("p", {
          className: "description-detail"
        }, /*#__PURE__*/React.createElement(NumberFormat, {
          value: item.value,
          displayType: "text",
          thousandSeparator: ".",
          decimalSeparator: ",",
          prefix: "$"
        }), " ", !!props.TranslateCurrencies ? props.TranslateCurrencies : "COP"));
      } else {
        return /*#__PURE__*/React.createElement("div", {
          key: item.order + "-" + item.name
        }, /*#__PURE__*/React.createElement("p", {
          className: "title-detail"
        }, item.name), /*#__PURE__*/React.createElement("p", {
          className: "description-detail"
        }, item.value, " ", item.name == "Área construida" ? "m" : "", item.name == "Área construida" ? /*#__PURE__*/React.createElement("sup", null, "2") : ""));
      }
    }
  })));
};
export default DetailsCard;